var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconIsk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#799AA9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.46016 21V12.4336H8.86055V21H7.46016ZM16.2676 18.6738C16.2676 19.4355 15.9922 20.0332 15.4414 20.4668C14.8906 20.9004 14.1309 21.1172 13.1621 21.1172C12.1934 21.1172 11.4004 20.9668 10.7832 20.666V19.3418C11.1738 19.5254 11.5879 19.6699 12.0254 19.7754C12.4668 19.8809 12.877 19.9336 13.2559 19.9336C13.8105 19.9336 14.2188 19.8281 14.4805 19.6172C14.7461 19.4062 14.8789 19.123 14.8789 18.7676C14.8789 18.4473 14.7578 18.1758 14.5156 17.9531C14.2734 17.7305 13.7734 17.4668 13.0156 17.1621C12.2344 16.8457 11.6836 16.4844 11.3633 16.0781C11.043 15.6719 10.8828 15.1836 10.8828 14.6133C10.8828 13.8984 11.1367 13.3359 11.6445 12.9258C12.1523 12.5156 12.834 12.3105 13.6895 12.3105C14.5098 12.3105 15.3262 12.4902 16.1387 12.8496L15.6934 13.9922C14.9316 13.6719 14.252 13.5117 13.6543 13.5117C13.2012 13.5117 12.8574 13.6113 12.623 13.8105C12.3887 14.0059 12.2715 14.2656 12.2715 14.5898C12.2715 14.8125 12.3184 15.0039 12.4121 15.1641C12.5059 15.3203 12.6602 15.4688 12.875 15.6094C13.0898 15.75 13.4766 15.9355 14.0352 16.166C14.6641 16.4277 15.125 16.6719 15.418 16.8984C15.7109 17.125 15.9258 17.3809 16.0625 17.666C16.1992 17.9512 16.2676 18.2871 16.2676 18.6738ZM24.6648 21H23.0418L20.3523 17.1211L19.5262 17.7949V21H18.1258V12.4336H19.5262V16.5234C19.909 16.0547 20.2898 15.6035 20.6687 15.1699L22.9832 12.4336H24.577C23.0809 14.1914 22.0086 15.4434 21.3602 16.1895L24.6648 21Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIsk);
export default __webpack_public_path__ + "static/media/icon-isk.47d49fc83aaed9415902930a822fdb8c.svg";
export { ForwardRef as ReactComponent };